import { apiRequest } from './client'
import type { AuditLogEntry, Paginated } from './types'

export const auditApi = {
  list: (
    params: {
      page?: number
      pageSize?: number
      userId?: string
      eventType?: string
      objectType?: string
      dateFrom?: string
      dateTo?: string
    } = {},
  ) => apiRequest<Paginated<AuditLogEntry>>('/audit', { query: params }),
}
